import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheFutureIsIntelligent from "./sections/TheFutureIsIntelligent";
import TechSynergyAiCloud from "./sections/TechSynergyAiCloud";
import ItConsulting from "./sections/ItConsulting";
import TheInaraPhilosophy from "./sections/TheInaraPhilosophy";
import YourInnovationRoadmap from "./sections/YourInnovationRoadmap";
import SuccessStories from "./sections/SuccessStories";
import RegionalImpact from "./sections/RegionalImpact";
import StartYourTransformation from "./sections/StartYourTransformation";
import WhyChooseInaraTechnologies from "./sections/WhyChooseInaraTechnologies";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <TheFutureIsIntelligent />
      <TechSynergyAiCloud />
      <ItConsulting />
      <TheInaraPhilosophy />
      <YourInnovationRoadmap />
      <SuccessStories />
      <RegionalImpact />
      <StartYourTransformation />
      <WhyChooseInaraTechnologies />
      <Footer />
    </div>;
}